/*
  ActionsSection.jsx
*/

// Npm.
import React from 'react';

// Lib.
import downloadFile from '../../../utils/downloadFile';

// Components.
import Button from '../../Button';

// Makes.
import { makeStyles } from '../../../makes/makeStyles';

// Styles.
const useStyles = makeStyles(theme => ({
  root: {
    '& > div:not(:last-of-type)': {
      marginBottom: theme.space(1),
    },
  }
}));

/**
 * Left sidebar component.
 */
export default function ActionsSection({
  className,
  canvasRef,
  forceGraphRef,
  disabled = false,
  onResetCamera,
}) {

  // Class.

  const classes = useStyles();

  let useClass = `${classes.root} body2`;

  if (className) {
    useClass += ` ${className}`;
  }

  // Handlers.

  function handleClickScreenshot() {
    if (canvasRef.current) {

      const name = 'screenshot.png';
      const type = 'image/png';
      const quality = 1;

      if (typeof canvasRef.current.toBlob === 'function') {
        canvasRef.current.toBlob((blob) => downloadFile(blob, name), type, quality);
      } else if (typeof canvasRef.current.toDataURL === 'function') {
        downloadFile(canvasRef.current.toDataURL(type, quality), name);
      }
      
    }
  }

  function handleClickResetCamera() {
    if (forceGraphRef.current) {
      forceGraphRef.current.zoomToFit(100);
    }
  }

  return (
    <div className={useClass}>

      <div>
        <Button
          onClick={handleClickScreenshot}
          disabled={disabled}
          fullWidth
        >
          Take Screenshot
        </Button>
      </div>

      <div>
        <Button
          onClick={handleClickResetCamera}
          disabled={disabled}
          fullWidth
        >
          Zoom to Fit
        </Button>
      </div>

    </div>
  );
}
